import React, { useEffect } from 'react';
import '@neftyblocks/market'; // sadece bu import yeterli
import './Market.css';

export default function MarketPage() {
  useEffect(() => {
    // bileşen kendi kendine çalışıyor, ekstra JS gerekmez
  }, []);

  return (
    <div className="market-container">
      <div className="market-widget">
        <neftyblocks-market
          collection="ranchersland"
          blockchain="wax"
          theme="dark"
          primary-color="#4CAF50"
          locale="en"
          show-filters="true"
        ></neftyblocks-market>
      </div>
    </div>
  );
}
